/**
 * Overview lazy route wrapper (routes/hm convention). Mounted in App.tsx inside the
 * AppShell ProtectedRoute tree, wrapped in RequireRole super_admin (OPS-05, Plan 04-09).
 */
import { lazy } from "react";

const OverviewPage = lazy(() =>
  import("@/features/overview/OverviewPage").then((m) => ({
    default: m.OverviewPage,
  })),
);

export function OverviewRoute() {
  return <OverviewPage />;
}
